/**
 * Product switches for features that are built but switched off.
 *
 * NOVEL_TRANSLATION_ENABLED — machine translation of a finished novel into
 * other languages (the Create page's "Also localize", the editor's Localize
 * card, the player's reading-language picker, the "+N" language badges and the
 * translation price row). Paused: each novel has exactly one language, which
 * the model detects from the idea at generation. The API's matching switch is
 * LOREVOK_NOVEL_TRANSLATION (off by default). Flip both to bring it back; the
 * translation code itself is untouched.
 */
export const NOVEL_TRANSLATION_ENABLED = false;

/**
 * STORYBOARD_CUES_ENABLED — the storyboard's media layers: a sound fired at a
 * frame and a special full-frame image/video replacing the stage. Built (data
 * model, validation, player) but hidden in the editor until there is a way to
 * make those assets; frames that already carry cues still play them.
 */
export const STORYBOARD_CUES_ENABLED = false;

/**
 * AUTHOR_SUPPORT_LINKS_ENABLED — the "Support the author" button on an author's
 * page (a link to their Boosty / Ko-fi / Patreon…) and its field in the profile
 * editor. Hidden while the payment provider reviews the site: a reviewer could
 * read an external donation link as Lorvok collecting donations or running a
 * marketplace, which merchant-of-record policies prohibit. Stored links are
 * kept (API and database untouched); flip back to show them again.
 */
export const AUTHOR_SUPPORT_LINKS_ENABLED = false;
